import { gql } from 'graphql-request'

export const createEquipment = gql`
  mutation CreateEquipment($siteId: String!, $input: CreateEquipmentInput!) {
    createEquipment(siteId: $siteId, input: $input) {
      equipmentId
      siteId
      name
      timerId
      minDelayMinutes
      maxDelayMinutes
      defaultDelayMinutes
      defaultTimerMinutes
      minTimerMinutes
      maxTimerMinutes
      category
      siteSessionTypeIds
      lastAvailableAt
      lastDelayAt
      lastInUseAt
      lastDirtyAt
      currentError {
        errorCode
        errorMessage
        errorAt
      }
      lastError {
        errorCode
        errorMessage
        errorAt
      }
      createdAt
      updatedAt
      manufacturer
      description
      qualityCategory
      image {
        db
        medium
        thumbnail
      }
    }
  }
`

export const updateEquipment = gql`
  mutation UpdateEquipment($input: UpdateEquipmentInput!, $equipmentId: String!) {
    updateEquipment(input: $input, equipmentId: $equipmentId) {
      equipmentId
      siteId
      name
      timerId
      minDelayMinutes
      maxDelayMinutes
      defaultDelayMinutes
      defaultTimerMinutes
      minTimerMinutes
      maxTimerMinutes
      category
      siteSessionTypeIds
      lastAvailableAt
      lastDelayAt
      lastInUseAt
      lastDirtyAt
      currentError {
        errorCode
        errorMessage
        errorAt
      }
      lastError {
        errorCode
        errorMessage
        errorAt
      }
      createdAt
      updatedAt
      manufacturer
      description
      qualityCategory
      image {
        db
        medium
        thumbnail
      }
    }
  }
`

export const getEquipmentImagePresignedUrlMutation = gql`
  mutation GenerateEquipmentImagePresignedUrl(
    $siteId: String!
    $equipmentId: String!
    $fileExtension: String!
  ) {
    generateEquipmentImagePresignedUrl(
      siteId: $siteId
      equipmentId: $equipmentId
      fileExtension: $fileExtension
    ) {
      tempUrl
      requestedBy
      userType
    }
  }
`

export const generateTanningEquipmentKeyMutation = gql`
  mutation GenerateTanningApiKey($siteId: String!) {
    generateTanningApiKey(siteId: $siteId)
  }
`

export const disableEquipment = gql`
  mutation DisableEquipment($equipmentId: String!) {
    disableEquipment(equipmentId: $equipmentId) {
      equipmentId
      status
      updatedAt
    }
  }
`

export const enableEquipment = gql`
  mutation EnableEquipment($equipmentId: String!) {
    enableEquipment(equipmentId: $equipmentId) {
      equipmentId
      status
      updatedAt
    }
  }
`

export const updateEquipmentStatus = gql`
  mutation UpdateEquipmentStatus($status: EquipmentStatus!, $equipmentId: String!) {
    updateEquipmentStatus(status: $status, equipmentId: $equipmentId) {
      equipmentId
    }
  }
`

export const resyncEquipments = gql`
  mutation ResyncEquipments($siteId: String!) {
    resyncEquipments(siteId: $siteId) {
      equipmentId
    }
  }
`

export const deleteEquipment = gql`
  mutation DeleteEquipment($equipmentId: String!) {
    deleteEquipment(equipmentId: $equipmentId)
  }
`

export const updateTanningIntegration = gql`
  mutation UpdateTanningIntegration($siteId: ID!, $input: UpdateTanningIntegrationInput!) {
    updateTanningIntegration(siteId: $siteId, input: $input) {
      siteId
    }
  }
`

export const requestMaintenance = gql`
  mutation RequestMaintenance(
    $siteId: String!
    $equipmentId: String!
    $subject: String!
    $bodyHtml: String!
  ) {
    requestMaintenance(
      siteId: $siteId
      equipmentId: $equipmentId
      subject: $subject
      bodyHtml: $bodyHtml
    )
  }
`

export const resetEquipment = gql`
  mutation ResetEquipment($equipmentId: String!) {
    resetEquipment(equipmentId: $equipmentId) {
      equipmentId
      status
    }
  }
`

export const tanningAgentDownloadUrlMutation = gql`
  mutation TanningAgentDownloadUrl {
    tanningAgentDownloadUrl {
      url
    }
  }
`
